import React, { useState } from "react";
import "./Notification.scss";
import { Popover } from "antd";
import NotificationCard from "./NotificationCard/NotificationCard";
import NotificationHeader from "./NotificationHeader/NotificationHeader";
import { Tab } from "react-bootstrap";
import NotificationEmpty from "./NotificationEmpty/NotificationEmpty";
import { useNavigate } from "react-router-dom";

const NotificationList = ({ notifications }) => {
  const navigate = useNavigate()

  function viewAll () {
    navigate('/notifications')
  }

  return (
    <div className="NotificationList">
      <div className="items">
        {notifications}
      </div>
      <div className="view-btn">
        <button className="btn btn-default" onClick={viewAll}>View All</button>
      </div>
    </div>
  )
}

const NotificationContent = ({ notifications }) => {
  function mapAndFilterNotifications(notifications, key = null) {
    let notificationList = notifications
    if (key) {
      notificationList = notificationList.filter(notification => notification.type === key)
    }
    notificationList = notificationList.map(notification => <NotificationCard key={notification.id} notification={notification} />)
    return notificationList.length ? <NotificationList notifications={notificationList} /> : <NotificationEmpty />
  }

  return (
    <div>
      <Tab.Container defaultActiveKey="all">
        <NotificationHeader />

        <Tab.Content>
          <Tab.Pane eventKey="all">
            {mapAndFilterNotifications(notifications)}
          </Tab.Pane>
          <Tab.Pane eventKey="better_price">
            {mapAndFilterNotifications(notifications, "PriceNotification")}
          </Tab.Pane>
          <Tab.Pane eventKey="updates">
            {mapAndFilterNotifications(notifications, "UpdateNotification")}
          </Tab.Pane>
          <Tab.Pane eventKey="docs">
            {mapAndFilterNotifications(notifications, "AttachmentNotification")}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  )
}

const Notification = ({ notifications, children }) => {
  return (
    <div>
      <Popover
        overlayClassName="Notification"
        content={<NotificationContent notifications={notifications} />}
        trigger="click"
      >
        {children}
      </Popover>
    </div>
  )
}

export default Notification;
